
export const AbilityType = {

    ON_CHANGE_ABILITY: "ON_CHANGE_ABILITY"
}